/** zh-CN catalogue `registry` (W3-09; English: src/app/registry/registry.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'registry',
  locale: 'zh-CN',
  messages: {
    modCtrl: 'Ctrl',
    modAlt: 'Alt',
    modShift: 'Shift',
    modCmd: 'Cmd',
    modOption: 'Option',
    keySpace: '空格',
    keyEnter: 'Enter',
    keyEscape: 'Esc',
    keyTab: 'Tab',
    keyBackspace: '退格',
    keyDelete: 'Del',
    keyInsert: 'Ins',
    keyHome: 'Home',
    keyEnd: 'End',
    keyPageUp: 'PgUp',
    keyPageDown: 'PgDn',
    keyArrowUp: '↑',
    keyArrowDown: '↓',
    keyArrowLeft: '←',
    keyArrowRight: '→',
    keyContextMenu: '菜单键',
    keyPause: 'Pause',
    keyPrintScreen: 'PrtSc',
    keyWheel: '滚轮',
    keyNumpad: '小键盘 {key}',
    labelHold: '按住 {label}',
    labelPhysical: '{label}（物理按键）',
    reservedTabsWindows: '浏览器用 {chord} 打开、关闭或恢复标签页和窗口；请换一个按键。',
    reservedTabSwitch: '浏览器保留 {chord} 用于切换标签页；请换一个按键。',
    reservedHistory: '浏览器用 {chord} 后退、前进或回到主页，这会离开编辑器；请换一个按键。',
    reservedCloseWindow: '在你的系统中 {chord} 会关闭窗口；请换一个按键。',
    reservedFullscreen: '{chord} 会让浏览器切换到全屏；请换一个按键。',
    reservedDevtools: '{chord} 会打开浏览器的开发者工具；请换一个按键。',
    reservedPrivate: '{chord} 会打开浏览器的隐私窗口；请换一个按键。',
    reservedAddons: '{chord} 会打开浏览器的扩展或标签页搜索；请换一个按键。',
    reservedBrowserTool: '{chord} 被浏览器自身占用；请换一个按键。',
    reservedScreenshot: '{chord} 会用浏览器自带的工具截图；请换一个按键。',
    reservedReload: '{chord} 会重新加载页面；请换一个按键。',
    reservedClearData: '{chord} 会打开浏览器的“清除浏览数据”窗口；请换一个按键。',
    reservedMacApp: '在 macOS 上，{chord} 会退出浏览器，或关闭、打开标签页和窗口；请换一个按键。',
    reservedMacWindow: '在 macOS 上，{chord} 会隐藏或最小化浏览器；请换一个按键。',
    reservedMacPrefs: '在 macOS 上，{chord} 会打开浏览器的设置；请换一个按键。',
    reservedMacCycle: '在 macOS 上，{chord} 会在浏览器窗口之间切换；请换一个按键。',
    reservedMacHistory: '在 macOS 上，{chord} 会让浏览器后退或前进，这会离开编辑器；请换一个按键。',
    reservedMacAddress: '在 macOS 上，{chord} 会跳到浏览器的地址栏；请换一个按键。',
    reservedMacLogout: '在 macOS 上，{chord} 会注销登录；请换一个按键。',
    reservedMacTabs: '在 macOS 上，{chord} 会切换浏览器标签页；请换一个按键。',
    reservedMacOther: '在 macOS 上，{chord} 被浏览器或系统占用；请换一个按键。',
    reservedCtrlAlt: '在许多键盘布局中 Ctrl+Alt 等同于 AltGr（用于输入 @ 或欧元符号等字符）；请换一个按键。',
    unreliableMenu: '部分浏览器用 {chord} 打开自己的菜单，因此它不一定总能传到 Phiedit。菜单和命令面板仍然可用。',
    unreliableAddress: '在部分浏览器中，{chord} 可能会把焦点移到地址栏。菜单和命令面板仍然可用。',
    unreliableDownloads: '在部分浏览器中，{chord} 会打开下载列表。菜单和命令面板仍然可用。',
    unreliableHistory: '在部分浏览器中，{chord} 会打开浏览历史。菜单和命令面板仍然可用。',
    importNotJson: '此文件不是有效的 JSON。',
    importWrongFormat: '此文件不是 Phiedit 键位文件。',
    importNewerVersion: '此键位由更新版本的 Phiedit 保存（格式 {version}）。',
    importBadPreset: '未知的键盘预设“{preset}”；已保留当前预设。',
    importBadAltFree: '“免 Alt”设置必须为 true 或 false；已保留当前设置。',
    importBadEntry: '第 {index} 项不是按键绑定。',
    importBadChord: '第 {index} 项：“{chord}”不是 Phiedit 能识别的按键或组合键。',
    importUnknownCommand: '第 {index} 项：没有名为“{command}”的命令。',
    importRefused: '第 {index} 项：{reason}',
    importBadWhen: '第 {index} 项：条件“{when}”无效（{error}）。',
    importNothingUsable: '此文件中的快捷键在这里都无法使用，因此你的快捷键未作更改。',
    issueInvalidChord: '“{chord}”不是 Phiedit 能识别的按键或组合键。',
    issueInvalidWhen: '“{command}”的快捷键 {chord} 的条件无效（{error}）。',
    issueUnknownCommand: '快捷键 {chord} 运行“{command}”，但此版本的 Phiedit 中没有该命令。',
    issueReserved: '“{command}”的快捷键 {chord} 被浏览器或系统占用，永远不会传到 Phiedit。',
    issueCtrlAlt: '“{command}”的快捷键 {chord} 使用了 Ctrl+Alt，在许多键盘布局中它等同于 AltGr。',
    issueAltFreeMissing: '“{command}”的快捷键 {chord} 使用了 Alt，但没有免 Alt 的替代按键。',
    issueMacMissing: '“{command}”的快捷键 {chord} 被 macOS 占用，但没有 macOS 替代按键。',
    issueMacShiftWheel: '“{command}”的快捷键 {chord} 依赖 Shift+滚轮，这在 Mac 上会横向滚动，但没有 macOS 替代按键。',
    issueBadAlternate: '“{command}”的快捷键 {chord} 的替代按键 {alternate} 无法使用。',
    issueRemoveInPreset: '“{command}”的内置快捷键 {chord} 被标记为已移除，而只有你自己的更改才能这样做。',
    issueUnreliable: '“{command}”的快捷键 {chord} 也被部分浏览器使用，因此它不一定总能传到 Phiedit。',
    issueConflict: '快捷键 {chord} 在同一情况下会同时运行“{command}”和“{other}”。',
    whenEmptyGroup: '空括号',
    whenUnexpectedEnd: '条件过早结束',
    whenUnexpected: '意外的“{token}”',
    whenUnclosed: '有一个“(”没有闭合',
    whenUnknownAtom: '未知的条件“{atom}”',
    whenUnknownName: '“{name}”无法比较',
    whenBadValue: '“{value}”不是 {name} 的有效值（请使用以下之一：{allowed}）',
    whenUnterminated: '一个带引号的值没有闭合',
    fullTitle: '“{command}”是完整模式的工具',
    fullBody: '你正在使用引导模式，它让编辑器保持简洁。你可以运行一次此命令，或切换到完整模式以查看它的所有工具。',
    fullRunOnce: '运行一次',
    fullRunOnceDetail: '留在引导模式',
    fullSwitch: '切换到完整模式',
    fullSwitchDetail: '从现在起显示所有工具（随时可在“设置”中更改）',
    commandFailed: '运行“{command}”时出现了问题。',
    focusNextRegion: '聚焦下一个面板',
    focusPreviousRegion: '聚焦上一个面板',
    closeDialogFirst: '请先关闭打开的对话框。',
  },
};

export default catalog;
